import { buttonClasses } from '@mui/material/Button';
import { Theme } from '@mui/material/styles';

import ArrowBackSvg from 'icons/monochrome/arrow-ios-back.svg';
import ArrowIosForwardSvg from 'icons/monochrome/arrow-ios-forward.svg';
import CalendarDuotoneSvg from 'icons/monochrome/calendar-duotone.svg';
import ChevronDownSvg from 'icons/monochrome/chevron-down.svg';
import ClockCircleSvg from 'icons/monochrome/clock-circle.svg';

// ----------------------------------------------------------------------

const dateList = [
  'DatePicker',
  'DateTimePicker',
  'StaticDatePicker',
  'DesktopDatePicker',
  'DesktopDateTimePicker',
  //
  'MobileDatePicker',
  'MobileDateTimePicker',
];

const timeList = ['TimePicker', 'MobileTimePicker', 'StaticTimePicker', 'DesktopTimePicker'];

const switchIcon = () => <ChevronDownSvg width={24} />;

const leftIcon = () => <ArrowBackSvg width={24} />;

const rightIcon = () => <ArrowIosForwardSvg width={24} />;

const calendarIcon = () => <CalendarDuotoneSvg width={24} />;

const clockIcon = () => <ClockCircleSvg width={24} />;

const desktopTypes = dateList.reduce((result: Record<string, object>, currentValue) => {
  result[`Mui${currentValue}`] = {
    defaultProps: {
      slots: {
        openPickerIcon: calendarIcon,
        leftArrowIcon: leftIcon,
        rightArrowIcon: rightIcon,
        switchViewIcon: switchIcon,
      },
    },
  };

  return result;
}, {});

const timeTypes = timeList.reduce((result: Record<string, object>, currentValue) => {
  result[`Mui${currentValue}`] = {
    defaultProps: {
      slots: {
        openPickerIcon: clockIcon,
        rightArrowIcon: rightIcon,
        switchViewIcon: switchIcon,
      },
    },
  };

  return result;
}, {});

export function datePicker(theme: Theme) {
  return {
    MuiPickersLayout: {
      styleOverrides: {
        root: {
          '& .MuiPickersLayout-actionBar': {
            [`& .${buttonClasses.root}:last-of-type`]: {
              backgroundColor: theme.palette.text.primary,
              color:
                theme.palette.mode === 'light'
                  ? theme.palette.common.white
                  : theme.palette.grey[800],
            },
          },
        },
      },
    },

    // Date
    ...desktopTypes,

    // Time
    ...timeTypes,
  };
}
